{
  "completed": "Ukończone: ",
  "current": "Aktualny: ",
  "notCompleted": "Nie ukończone: ",
  "steplist": "Lista kroków"
}
